const LandingPage = ({ width = "272", height = "272" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 272 272"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dddd_16_6)">
        <circle
          cx="136"
          cy="135"
          r="99"
          fill="white"
          fillOpacity="0.5"
          shapeRendering="crispEdges"
        />
        <circle
          cx="136"
          cy="135"
          r="98"
          stroke="white"
          strokeWidth="2"
          shapeRendering="crispEdges"
        />
      </g>
      <circle cx="136" cy="135" r="85" fill="#08183F" stroke="white" strokeWidth="2" />
      <g filter="url(#filter1_d_16_6)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95 134.882C95 112.002 113.548 93.4545 136.427 93.4545C159.307 93.4545 177.855 112.002 177.855 134.882C177.855 157.761 159.307 176.309 136.427 176.309C113.548 176.309 95 157.761 95 134.882ZM136.427 98.732C116.462 98.732 100.278 114.917 100.278 134.882C100.278 154.847 116.462 171.032 136.427 171.032C156.392 171.032 172.577 154.847 172.577 134.882C172.577 114.917 156.392 98.732 136.427 98.732Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M111.064 142.859V85H116.368V142.859C116.368 148.12 120.617 152.385 125.859 152.385C131.101 152.385 135.351 148.12 135.351 142.859V123.017H140.655V142.859C140.655 151.061 134.03 157.709 125.859 157.709C117.688 157.709 111.064 151.061 111.064 142.859Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M147.759 140.8L127.127 140.8L127.127 135.496L147.759 135.496C153.03 135.496 157.303 131.247 157.303 126.005C157.303 120.763 153.03 116.513 147.759 116.513L127.127 116.513L127.127 111.209L147.759 111.209C155.976 111.209 162.637 117.833 162.637 126.005C162.637 134.176 155.976 140.8 147.759 140.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.166 178L150.8 139.533L155.57 137.418L171.936 175.885L167.166 178Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddd_16_6"
          x="0"
          y="0"
          width="272"
          height="272"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9" dy="12" />
          <feGaussianBlur stdDeviation="8.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0112674 0 0 0 0 0.0188719 0 0 0 0 0.0458333 0 0 0 0.48 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_6" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="18.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.588235 0 0 0 0 0.776471 0 0 0 0.57 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow_16_6" result="effect2_dropShadow_16_6" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.67 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_16_6" result="effect3_dropShadow_16_6" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.588235 0 0 0 0 0.776471 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="effect3_dropShadow_16_6" result="effect4_dropShadow_16_6" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_16_6" result="shape" />
        </filter>
        <filter
          id="filter1_d_16_6"
          x="84"
          y="74"
          width="104.854"
          height="115"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.588235 0 0 0 0 0.776471 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_6" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_6" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default LandingPage;
